// import ReactECharts from "echarts-for-react";
// import { palette, theme as colorTheme } from "../../../../Convoze.theme";

// function CampaignAnalytics({
//    cardDetails
// } ) {

//   // console.log("Inside campaign Analytics", cardDetails);

//   const campaignNames = cardDetails?.campaigns?.campaignNames || [];
//   const campaignCounts = cardDetails?.campaigns?.campaignCounts || [];
//   const hasData = campaignNames.length && campaignCounts.length;

//   const option = {
//     title: { text: "Campaign Analytics", left: "left", fontSize: 10 },
//     color:[colorTheme('palette', 'primary').value, "#c8cee2ff"],
//     tooltip: { trigger: "axis", axisPointer: { type: "shadow" } },
//     legend: { left: "right" },
//     grid: { left: "3%", right: "4%", bottom: "3%", containLabel: true },
//     xAxis: [
//       {
//         type: "category",
//         data: campaignNames,
//         axisLabel: { rotate: 30, fontSize: 10 },
//       },
//     ],
//     yAxis: [{ type: "value" }],
//     series: [
//       {
//         name: "Campaign",
//         type: "bar",
//         barWidth: 28,
//         emphasis: { focus: "series" },
//         itemStyle: { borderRadius: [2, 2, 0, 0] },
//         data: campaignCounts,
//       },
//     ],
//   };

//   return (
//     <>
//       {!hasData ? (
//         <div
//           style={{
//             height:"50vh",
//             width: "100%",
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//             fontSize: "1rem",
//             fontWeight: 600,
//             color: "#999",
//           }}
//         >
//           No data available
//         </div>
//       ) : (
//         <ReactECharts
//           option={option}
//           style={{ height:"50vh", width: "100%" }}
//           opts={{ renderer: "svg" }}
//         />
//       )}
//     </>
//   );
// }

// export default CampaignAnalytics;
import ReactECharts from "echarts-for-react";
import * as echarts from "echarts";
import { Box, Typography } from "@mui/material";
import { theme as colorTheme } from "../../../../Convoze.theme";

function CampaignAnalytics({ cardDetails }) {
  const campaignNames = cardDetails?.campaigns?.campaignNames || [];
  const campaignCounts = cardDetails?.campaigns?.campaignCounts || [];
  const hasData = campaignNames?.length > 0 && campaignCounts?.length > 0;

  const option = {
    title: {
      text: "Campaign Analytics",
      left: "left",
      textStyle: {
        fontSize: 14,
        fontWeight: 700,
        color: "#464646",
      },
    },
    tooltip: { trigger: "axis", axisPointer: { type: "shadow" } },
    legend: { left: "right" },
    grid: { left: "3%", right: "4%", bottom: "3%", containLabel: true },
    xAxis: [
      {
        type: "category",
        data: campaignNames,
        axisLabel: { rotate: 30, fontSize: 10 },
      },
    ],
    yAxis: [{ type: "value" }],
    series: [
      {
        name: "Campaign",
        type: "bar",
        barWidth: 28,
        emphasis: { focus: "series" },
        itemStyle: {
          borderRadius: [4, 4, 0, 0],
          color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
            { offset: 0, color: "#2196F3" }, // top
            { offset: 1, color: "#64B5F6" }, // bottom
          ]),
        },
        data: campaignCounts,
      },
    ],
  };

  return (
    <Box
      sx={{
        height: "50vh",
        width: "100%",
        display: "flex",
        flexDirection: "column",
      }}
    >
      {!hasData && (
        <Box
          width="100%"
          display="flex"
          justifyContent="space-between"
          mb="20px"
        >
          <Typography
            fontSize={14}
            variant="body2"
            color="#464646"
            fontWeight={700}
          >
            Campaign Analytics
          </Typography>
        </Box>
      )}

      {/* Chart or No Data */}
      {hasData ? (
        <ReactECharts
          option={option}
          style={{ flex: 1 }}
          opts={{ renderer: "svg" }}
        />
      ) : (
        <Box
          flex={1}
          display="flex"
          alignItems="center"
          justifyContent="center"
          fontSize="1rem"
          fontWeight={600}
          color="#999"
          borderRadius="8px"
        >
          No data available
        </Box>
      )}
    </Box>
  );
}

export default CampaignAnalytics;